import { type Transaction } from '@kalos/kalos-rpc';

import { NULL_TIME } from '../../../../constants';
import { prettyMoney } from '../../../../tools/helpers';

// Format transaction for standard export
export const formatTransactionForExport = (transaction: Transaction) => {
  // Map status ID to status name
  const getStatusName = (statusId: number) => {
    switch (statusId) {
      case 2:
        return 'Pending';
      case 3:
        return 'Accepted';
      case 4:
        return 'Rejected';
      case 5:
        return 'Processed';
      default:
        return `Status ${statusId}`;
    }
  };

  return {
    Date: new Date(transaction.timestamp.split(' ').join('T')).toLocaleDateString(),
    'Due Date':
      transaction.paymentDueDate && transaction.paymentDueDate !== NULL_TIME
        ? new Date(transaction.paymentDueDate.split(' ').join('T')).toLocaleDateString()
        : '',
    'Purchase Order #': transaction.orderNumber || '',
    'Invoice #': transaction.invoiceNumber || '',
    'Purchaser/PM': transaction.ownerName || '',
    Creator: transaction.assignedEmployeeName || '',
    Department: transaction.department?.description || '',
    'Job #': transaction.jobId ? `#${transaction.jobId}` : '',
    'Cost Center': transaction.costCenter?.description || '',
    Amount: prettyMoney(transaction.amount),
    Vendor: transaction.vendor || '',
    Notes: transaction.notes || '',
    Status: getStatusName(transaction.statusId || 0),
  };
};

// Format transaction for QuickBooks export
export const formatTransactionForQuickBooks = (transaction: Transaction) => {
  return {
    Date: new Date(transaction.timestamp.split(' ').join('T')).toLocaleDateString(),
    'Due Date':
      transaction.paymentDueDate && transaction.paymentDueDate !== NULL_TIME
        ? new Date(transaction.paymentDueDate.split(' ').join('T')).toLocaleDateString()
        : '',
    'Invoice #': transaction.invoiceNumber || '',
    'Invoice/Vendor Credit': '',
    'Job #': transaction.jobId ? `#${transaction.jobId}` : '',
    Vendor: transaction.vendor || '',
    'Unit Price': transaction.amount || 0,
    Category: transaction.costCenter?.description || '',
    Class: transaction.department?.description || '',
  };
};
